import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AtlasBidFact {
  bid_id: string;
  broker_company_name: string;
  bid_amount: number;
  rpm: number | null;
  vs_budget_max: number | null;
  eta_hours: number | null;
  team_available: boolean;
  truck_in_area: boolean;
  ready_to_cover: boolean;
  verified: boolean;
  credit_score: number | null;
  note: string;
  chips: string[];
}

export interface AtlasAwardAnalysis {
  confidence: "low" | "medium";
  ranking: { bid_id: string; rank: number; rationale: string }[];
  tradeoff: { text: string } | null;
  bids: AtlasBidFact[];
  team_required: boolean;
  generated_at: string;
}

export function useAtlasAwardAnalysis(
  loadId: string | undefined,
  opts: { enabled: boolean; bidsFingerprint: string },
) {
  return useQuery({
    queryKey: ["atlas-award-analysis", loadId, opts.bidsFingerprint],
    enabled: !!loadId && opts.enabled,
    staleTime: 60_000,
    retry: false,
    queryFn: async (): Promise<AtlasAwardAnalysis | { insufficient: true }> => {
      const { data, error } = await supabase.functions.invoke("atlas-award-analysis", {
        body: { load_id: loadId, bids_fingerprint: opts.bidsFingerprint },
      });
      if (error) throw error;
      if (data?.error === "insufficient_bids") return { insufficient: true };
      if (data?.error) throw new Error(data.error);
      return data as AtlasAwardAnalysis;
    },
  });
}

